import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import store from "../stores/store";
import { register } from "ol/proj/proj4";
import {
  addMapLayer,
  getMapCenter,
  getMapProjection,
  getZoomLevel,
} from "../components/map/mapUtils";
import {
  formatSearchResultsFromServiceResponse,
  getAttributesFromGeoJSON,
  getGeoJSONData,
} from "./featureUtils";
import moment from "moment";
import proj4 from "proj4";
import { walk } from "react-sortable-tree";
import { AlertList } from "react-bs-notifier";
import ReactDOM from "react-dom";
var md5 = require("md5");

export function trans(translation) {
  //console.log("translation", translation);

  if (window["translations"]) {
    return window["translations"][translation]
      ? window["translations"][translation]
      : translation;
  }
  return translation;
}

export function fetch(
  url,
  method = "GET",
  headers = {},
  data = null,
  callback = null,
  responseType = null,
  params = null,
  onUploadProgress = null,
  cancelToken = null,
  async = false
) {
  console.log(data);
  const a = new axios(
    {
      url: url,
      method: method,
      data: data,
      headers: headers,
      responseType: responseType,
      params: params,
      onUploadProgress: onUploadProgress,
      cancelToken: cancelToken,
    },
    {}
  )
    .then(callback)
    .catch((error) => {
      console.log(error);
    });

  return a;
}

export function MapViewConfig() {
  if (GetParameterByName("lon") && GetParameterByName("lat")) {
    return {
      projection: GetParameterByName("proj")
        ? GetParameterByName("proj")
        : "EPSG:4326",
      center: [
        Number(GetParameterByName("lon")),
        Number(GetParameterByName("lat")),
      ],
      zoom: GetParameterByName("zoom") ? Number(GetParameterByName("zoom")) : 6,
    };
  }
  if (window["appConfig"]()["mapView"]()) {
    return window["appConfig"]()["mapView"]();
  }

  return {
    projection: "EPSG:4326",
    center: [23.704764001367, 38.002281696053],
    zoom: 6,
  };
}

export function getURLPath(index, url = window.location.pathname) {
  if (window["appConfig"]()["path"]() !== "/") {
    url = url.replace(window["appConfig"]()["path"](), "");
  }

  let splitUrl = url.split("/");

  if (Object.keys(window["availableLangugages"]).indexOf(splitUrl[1]) >= 0) {
    return splitUrl[index + 1];
  }

  return splitUrl[index];
}

export function buildAppURL(url) {
  return window["appConfig"]()
    ["path"]()
    .concat(window["currentLangugage"], url);
}

export function exportConfiguration(
  layers,
  layerTree,
  registeredLayerTree,
  map,
  bookmarks
) {
  function reccursive(data) {
    return data?.map((el) => {
      if (el.type === "layer" && el.layer.source.type !== "GEOJSON") {
        el.layer = { ...layers[el.layer.id] };

        el.layer.legend = null;
      }

      reccursive(el.children);

      return el;
    });
  }

  let layerTreeConfiguration = reccursive([...layerTree]);

  let configuration = window["appConfig"]();

  let newConfiguration = 'window["appConfig"] = () => {return {';

  Object.keys(configuration).forEach((el) => {
    if (typeof configuration[el] === "function") {
      newConfiguration += el.concat(":", configuration[el], ",");
    } else if (el.startsWith("layerTree")) {
      if (el === "layerTree") {
        newConfiguration += "layerTree".concat(
          ":",
          JSON.stringify(layerTreeConfiguration),
          ","
        );
        newConfiguration += "endLayerTree:null,";
      }
    } else if (el === "registeredLayerTree") {
      newConfiguration += "registeredLayerTree".concat(
        ":",
        JSON.stringify(registeredLayerTree),
        ","
      );
    } else if (el === "bookmarks") {
      newConfiguration += "bookmarks".concat(
        ":",
        JSON.stringify(bookmarks),
        ","
      );
    } else {
      newConfiguration += el.concat(
        ":",
        JSON.stringify(configuration[el]),
        ","
      );
    }
  });

  newConfiguration = newConfiguration.slice(0, -1);

  newConfiguration += "}}";

  download("config.js", newConfiguration, "application/json");
}

export function download(filename, text, contentType) {
  var element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:" + contentType + ";charset=utf-8," + encodeURIComponent(text)
  );
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export function copyToClipboard(text) {
  var dummy = document.createElement("textarea");
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand("copy");
  document.body.removeChild(dummy);
}

export function getAppUrl() {
  let center = getMapCenter();

  let zoom = getZoomLevel();

  let projection = getMapProjection();

  var url = new URL(window.location.href);

  url.searchParams.set("lon", center[0]);

  url.searchParams.set("lat", center[1]);

  url.searchParams.set("zoom", zoom);

  url.searchParams.set("proj", projection);

  return url.toString();
}

export function loadConfiguration() {}

export function createNotification(args, target) {
  let notification = [];

  if (args) {
    notification = [
      {
        id: new Date().getTime(),
        type: args.type,
        message: <span className="pr-2">{args.message}</span>,
      },
    ];
  }

  ReactDOM.render(
    <AlertList
      alerts={notification}
      timeout={2000}
      onDismiss={(item) => {
        createNotification(null);
      }}
    />,
    document.getElementById(target ? target : "notification")
  );
}

export function appInit(layerTree, registeredLayerTree) {
  //Layer tree
  const registerSources = [];
  const registerSourcesURL = [];
  const layerTreeIds = [];

  walk({
    treeData: layerTree,
    getNodeKey: ({ treeIndex }) => treeIndex,
    ignoreCollapsed: false,
    callback: (rowInfoIter) => {
      const node = rowInfoIter.node;
      switch (node.type) {
        case "layer":
          if (node.layer.source.type === "GEOJSON") {
            addCustomLayer(node);
          } else {
            if (registerSourcesURL.indexOf(node.layer.source.url) < 0) {
              registerSources.push(fetchLayersRequest(node.layer.source));
              registerSourcesURL.push(node.layer.source.url);
            }
            layerTreeIds.push(node.id);
          }
          break;
      }
    },
  });

  function addCustomLayer(customLayer) {
    let source = {
      id: md5(customLayer.layer.source.url),
      type: "GEOJSON",
      name: "GeoJSON",
      title: customLayer.title,
      url: customLayer.layer.source.url,
    };

    store.dispatch({
      type: "source/add",
      payload: { [source.id]: source },
    });

    let randomColor = Math.floor(Math.random() * 16777215).toString(16);

    let layer = formatGEOJSONLayer({
      id: getLayerIdByName(
        customLayer.layer.name,
        customLayer.layer.source.url
      ),
      name: customLayer.layer.name,
      title: customLayer.title,
      projection: "EPSG:4326",
      visibility: customLayer.layer.visibility,
      opacity: 1,
      nativeProjection: "EPSG:4326",
      attributes: getAttributesFromGeoJSON(JSON.parse(source.url)),
      legend: window["appConfig"]()["api"](
        "?proxy=color&color=".concat(randomColor)
      ),
      color: randomColor,
      bbox: [],
      abstract: "GeoJSON File ".concat(customLayer.layer.name),
    });

    layer.source = source;

    store.dispatch({
      type: "layer/state/append",
      payload: { [layer.id]: layer },
    });
  }

  fetch(window["appConfig"]()["api"](), "POST", {}, registerSources, (resp) => {
    const sources = fetchSourceResponseFormatter(resp.data);

    store.dispatch({ type: "source/add", payload: sources });

    let allLayers = {};

    resp.data?.forEach((el) => {
      el._response._layers?.forEach((layer) => {
        if (layerTreeIds.indexOf(layer._layerId) >= 0) {
          allLayers[layer._layerId] = updateLayerPropertiesFromConfig(
            layerResponseFormatter(layer),
            layerTree
          );
          allLayers[layer._layerId].source = {
            id: el._response._serviceId,
            url: el._response._serviceUrl,
            type: el._response._serviceType,
          };
          allLayers[layer._layerId].loaded = true;

          if (allLayers[layer._layerId]["attributes"].length < 1) {
            fetch(
              window["appConfig"]()["api"](),
              "POST",
              {},
              [registerLayerRequest(allLayers[layer._layerId])],
              (lresp) => {
                let lresponse = layerResponseFormatter(lresp.data[0]._response);

                console.log(lresponse);

                let newLayer = { ...allLayers[layer._layerId] };

                // newLayer["geometryType"] = null;
                // newLayer["geometryIsMulti"] = null;

                if (newLayer["attributes"].length < 1) {
                  store.dispatch({
                    type: "layer/update",
                    payload: {
                      id: layer._layerId,
                      property: "attributes",
                      value: lresponse.attributes,
                    },
                  });

                  // newLayer["attributes"].forEach((attr) => {
                  //   if (attr.isGeometry) {
                  //     lresponse["geometryType"] = attr.type;
                  //     lresponse["geometryIsMulti"] = attr.geometryIsMulti;
                  //   }
                  // });
                }

                Object.keys(newLayer).forEach((el) => {
                  if (!newLayer[el]) {
                    if (lresponse[el]) {
                      setTimeout(() => {
                        store.dispatch({
                          type: "layer/update",
                          payload: {
                            id: layer._layerId,
                            property: el,
                            value: lresponse[el],
                          },
                        });
                      }, 0);
                    }
                  }
                });
              }
            );
          } else {
            allLayers[layer._layerId]["attributes"].forEach((attr) => {
              if (attr.isGeometry) {
                allLayers[layer._layerId]["geometryType"] = attr.type;
                allLayers[layer._layerId]["geometryIsMulti"] =
                  attr.geometryIsMulti;
              }
            });
          }
        }
      });
    });

    store.dispatch({ type: "layer/state/append", payload: allLayers });
  });

  const registeredLayerTreeIds = [];

  walk({
    treeData: registeredLayerTree,
    getNodeKey: ({ treeIndex }) => treeIndex,
    ignoreCollapsed: false,
    callback: (rowInfoIter) => {
      const node = rowInfoIter.node;
      switch (node.type) {
        case "layer":
          if (registerSourcesURL.indexOf(node.layer.source.url) < 0) {
            registerSources.push(fetchLayersRequest(node.layer.source));
            registerSourcesURL.push(node.layer.source.url);
          }
          registeredLayerTreeIds.push(node.id);
          break;

        case "service":
          console.log(node);
          fetch(
            window["appConfig"]()["api"](),
            "POST",
            {},
            [registerServiceRequest(node.source)],
            (resp) => {
              if (resp.data) {
                if (resp.data[0]) {
                  if (resp.data[0]._response) {
                    if (resp.data[0]._response._serviceId) {
                      const sourcetmp = fetchSourceResponseFormatter(resp.data);

                      store.dispatch({
                        type: "source/add",
                        payload: sourcetmp,
                      });
                    }
                  }
                }
              }
            }
          );

          break;
      }
    },
  });

  fetch(window["appConfig"]()["api"](), "POST", {}, registerSources, (resp) => {
    const sources = fetchSourceResponseFormatter(resp.data);

    store.dispatch({ type: "source/add", payload: sources });

    let allLayers = {};

    resp.data?.forEach((el) => {
      el._response._layers?.forEach((layer) => {
        if (registeredLayerTreeIds.indexOf(layer._layerId) >= 0) {
          allLayers[layer._layerId] = updateLayerPropertiesFromConfig(
            layerResponseFormatter(layer),
            registeredLayerTree
          );
          allLayers[layer._layerId].source = {
            id: el._response._serviceId,
            url: el._response._serviceUrl,
            type: el._response._serviceType,
          };
          allLayers[layer._layerId].loaded = true;
        }
      });
    });

    store.dispatch({
      type: "registeredLayerTree/state/layers/update",
      payload: allLayers,
    });
  });
}

export function getProjectionCode(code) {
  if (code) {
    if (code.startsWith("urn:ogc:def:crs:")) {
      return code.split("urn:ogc:def:crs:")[1].replace("::", ":");
    } else if (code.startsWith("http://www.opengis.net/gml/srs/epsg.xml#")) {
      return "EPSG".concat(
        ":",
        code.split("http://www.opengis.net/gml/srs/epsg.xml#")[1]
      );
    }
  }

  if (code) {
    if (!proj4.defs[code]) {
      fetch(
        window["appConfig"]()["api"](
          "?proxy=raw&contenttype=".concat(
            "plain/text",
            "&url=",
            "https://spatialreference.org/ref/epsg/" +
              code.split(":")[1] +
              "/proj4js/"
          )
        ),
        "GET",
        {},
        null,
        (resp) => {
          let respCode = resp.data;

          if (respCode) {
            proj4.defs(
              code,
              respCode.split(" = ")[1].replace(";", "").replace('"', "")
            );
            register(proj4);
          }
        }
      );
    }
  }

  return code;
}

export async function fetchAsync(
  url,
  method = "GET",
  headers = {},
  data = null,
  callback = null,
  responseType = null,
  params = null,
  onUploadProgress = null,
  cancelToken = null,
  async = false
) {
  return await axios({
    url: url,
    method: method,
    data: data,
    headers: headers,
    responseType: responseType,
    params: params,
    onUploadProgress: onUploadProgress,
    cancelToken: cancelToken,
  });
}

export function formatSelectedFeatures(selected, stored) {
  let selectedFiltered = stored ? stored : [];

  if (Array.isArray(selected)) {
    let tmpSelected = [];

    selected?.forEach((el) => {
      if (selectedFiltered.indexOf(el._featureId) < 0) {
        tmpSelected.push(el._featureId);
      }
    });

    selectedFiltered = [...tmpSelected];
  } else {
    let selectedExistIndex = null;

    selectedFiltered?.forEach((el, idx) => {
      if (selected._featureId === el) {
        selectedExistIndex = idx;
      }
    });

    if (selectedExistIndex !== null) {
      selectedFiltered.splice(selectedExistIndex, 1);
    } else {
      selectedFiltered.push(selected._featureId);
    }
  }

  return selectedFiltered;
}

export function GetParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function key() {
  return "key-".concat(uuidv4());
}

export function getLayerIdByName(layerName, sourceUrl) {
  return md5(sourceUrl).concat(md5(layerName));
}

export function showDataTable(layer, source) {
  if (source.type === "GEOJSON") {
    let data = getGeoJSONData(JSON.parse(source.url));
    store.dispatch({
      type: "results/dataTableResults/update",
      payload: { id: layer.id, data: data, params: { total: data.length } },
    });
  } else {
    let url = "?proxy=pager&start={start}&limit={limit}";

    let cqlFilter = layer.cqlFilter ? layer.cqlFilter : "1=1";

    cqlFilter = cqlFilter.concat(
      "&COUNT={limit}&STARTINDEX={start}&SORTBY={sortby}"
    );

    fetch(
      window["appConfig"]()
        ["api"](url)
        .replace("{start}", 0)
        .replace("{limit}", 50),
      "POST",
      {},
      [
        {
          _layerId: layer.id,
          _serviceType: source.type,
          _servicePort: source.port,
          _serviceName: source.name,
          _username: source.username,
          _serviceUrl: source.url,
          _password: source.password,
          _layerName: layer.name,
          _version: source.version,
          _isService: true,
          _geometryField: layer.geometryField,
          _cqlFilter: cqlFilter,
          _geomFilter: null,
          _nativeSRS: layer.nativeProjection,
          _featureInfoFormat: "application/vnd.ogc.gml",
          _request: "search",
        },
      ],
      (resp) => {
        store.dispatch({
          type: "results/dataTableResults/update",
          payload: {
            id: layer.id,
            data: formatSearchResultsFromServiceResponse(resp.data),
            params: { total: resp.data?.data[0]?._response._total },
          },
        });
      }
    );
  }
}

export function formatGEOJSONLayer(response) {
  let {
    id,
    name,
    title,
    projection,
    legend,
    color,
    bbox,
    abstract,
    attributes,
    geometryType,
    geometryIsMulti,
  } = response;

  let layer = {
    id: id,
    name: name,
    title: title,
    abstract: abstract,
    singleTile: false,
    slds: [],
    searchable: true,
    editCanCopy: true,
    editCanTrace: true,
    editCanSnapVertex: true,
    editCanSnapEdge: true,
    nativeProjection: projection,
    projections: [projection],
    visibility: true,
    opacity: 0.8,
    xy: true,
    geometryType: geometryType,
    geometryIsMulti: geometryIsMulti,
    geometryField: "geometry",
    attributes: attributes,
    transparent: true,
    tiled: false,
    scales: null,
    editable: true,
    bbox: bbox,
    dimensions: null,
    defaultDimension: null,
    elevation: null,
    defaultElevation: null,
    queryable: true,
    metadata: {
      url: null,
    },
    legend: legend,
    cqlFilter: null,
    color: color,
  };

  return layer;
}

export function featureInfoRequest(layer, source) {
  return {
    _layerId: layer.id,
    _serviceType: source.type,
    _servicePort: source.port,
    _serviceName: source.name,
    _username: source.username,
    _serviceUrl: source.url,
    _password: source.password,
    _layerName: layer.name,
    _version: source.version,
    _isService: true,
    _geometryField: layer.geometryField,
    _cqlFilter: null,
    _geomFilter: null,
    _nativeSRS: layer.nativeProjection,
    _featureInfoFormat: "application/vnd.ogc.gml",
    _request: "getInfo",
  };
}

export function fetchLayersRequest(source) {
  return {
    _serviceType: source?.type,
    _serviceUrl: source?.url,
    _request: "fetchLayers",
    _username: source?.username,
    _password: source?.password,
  };
}

export function registerServiceRequest(source) {
  return {
    _serviceType: source?.type,
    _serviceUrl: source?.url,
    _request: "registerService",
    _username: source?.username,
    _password: source?.password,
  };
}

export function addLayer(layer, layerTree, unshift) {
  switch (layer.source.type) {
    case "GEOJSON":
      let updatedLayer = updateLayerPropertiesFromConfig(layer, layerTree);

      updatedLayer.loaded = true;
      store.dispatch({
        type: unshift ? "layer/unshift" : "layer/add",
        payload: updatedLayer,
      });

      addMapLayer(updatedLayer);

      break;

    case "WMTS":
      fetch(
        window["appConfig"]()["api"](),
        "POST",
        {},
        [registerLayerRequest(layer)],
        (resp) => {
          let response = layerResponseFormatter(resp.data[0]._response);

          let newLayer = { ...layer };

          Object.keys(newLayer).forEach((el) => {
            if (!newLayer[el]) {
              if (response[el]) {
                newLayer[el] = response[el];
              }
            }
          });

          newLayer.wmts = { ...response.wmts };
          newLayer.loaded = true;

          if (layerTree) {
            let updatedLayer = updateLayerPropertiesFromConfig(
              newLayer,
              layerTree
            );

            store.dispatch({
              type: unshift ? "layer/unshift" : "layer/add",
              payload: updatedLayer,
            });

            addMapLayer(updatedLayer);
          } else {
            store.dispatch({
              type: unshift ? "layer/unshift" : "layer/add",
              payload: newLayer,
            });

            addMapLayer(newLayer);
          }
        }
      );
      break;

    default:
      fetch(
        window["appConfig"]()["api"](),
        "POST",
        {},
        [registerLayerRequest(layer)],
        (resp) => {
          let response = layerResponseFormatter(resp.data[0]._response);

          let newLayer = { ...layer };

          Object.keys(newLayer).forEach((el) => {
            if (!newLayer[el]) {
              if (response[el]) {
                newLayer[el] = response[el];
              }
            }
          });

          newLayer.loaded = true;
          newLayer.singleTile = true;
          if (layerTree) {
            let updatedLayer = updateLayerPropertiesFromConfig(
              newLayer,
              layerTree
            );

            store.dispatch({
              type: unshift ? "layer/unshift" : "layer/add",
              payload: updatedLayer,
            });

            addMapLayer(updatedLayer);
          } else {
            store.dispatch({
              type: unshift ? "layer/unshift" : "layer/add",
              payload: newLayer,
            });

            addMapLayer(newLayer);
          }
        }
      );
      break;
  }
}

export function registerLayerRequest(layer) {
  return {
    _serviceType: layer.source.type,
    _serviceUrl: layer.source.url,
    _request: "registerLayer",
    _username: layer.source.username,
    _password: layer.source.password,
    _layerName: layer.name,
    _layerId: layer.id,
  };
}

export function searchLayerRequest(layer, source, cqlFilter, cqlFilterJSON) {
  return {
    _layerId: layer.id,
    _serviceType: source.type,
    _serviceName: source.name,
    _servicePort: source.port,
    _username: source.username,
    _serviceUrl: source.url,
    _password: source.password,
    _layerName: layer.name,
    _version: source.version,
    _isService: true,
    _cqlFilter: cqlFilter,
    _cqlFilterJSON: cqlFilterJSON,
    _geometryField: layer.geometryField,
    _nativeSRS: layer.nativeProjection,
    _geomFilter: "",
    _featureInfoFormat: "application/vnd.ogc.gml",
    _request: "search",
  };
}

export function updateLayerPropertiesFromConfig(layer, layerTree) {
  const configLayer = getConfigLayer(layer.id, layerTree);

  let currentLayer = { ...layer };

  if (configLayer) {
    Object.keys(currentLayer).forEach((el) => {
      if (configLayer[el]) {
        if (el === "_nativeSRS") {
          currentLayer[el] = getProjectionCode(configLayer[el]);
        } else if (el === "_supportedEPSG") {
          currentLayer[el] = configLayer[el].map((el) => {
            return getProjectionCode(el);
          });
        } else {
          currentLayer[el] = configLayer[el];
        }
      }

      if (el === "visibility") {
        currentLayer[el] = configLayer[el];
      }
      // if (el === "opacity") {
      //   currentLayer[el] = parseFloat(configLayer[el]);
      // }
    });
  }

  return currentLayer;
}

export function getConfigLayer(id, layerTree) {
  let layer = null;
  function reccursive(data) {
    data?.forEach((el) => {
      if (el.type === "layer") {
        if (el.layer.id === id) {
          layer = el.layer;
        }
      }

      reccursive(el.children);
    });
  }

  reccursive(layerTree);

  return layer;
}

export function getProjectionConfig(projection) {
  let config = null;
  window["appConfig"]()["projectionSystems"].forEach((el) => {
    if (el.code === projection) {
      config = el;
    }
  });

  return config;
}

export function layerResponseFormatter(response) {
  let geometryField = response._geometryField;
  let geometryType = response.geometryType;
  let geometryIsMulti = response.geometryIsMulti;

  if (response._attributes) {
    response._attributes?.map((el) => {
      if (el._attributeIsGeometry) {
        if (!geometryField) {
          geometryField = el._attributeName;
        }

        if (!geometryType) {
          geometryType = el._attributeType;
        }

        if (!geometryIsMulti) {
          geometryIsMulti = el._geometryIsMulti;
        }
      }
    });
  }

  return {
    id: response._layerId,
    name: response._layerName,
    title: response._layerTitle,
    abstract: response._layerAbstract,
    singleTile: response._singleTile,
    slds: response._layerSLDs?.map((el) => {
      return { body: el, url: el, title: el, type: "predefined" };
    }),
    searchable: response._isSearchable,
    nativeProjection: getProjectionCode(response._nativeSRS),
    projections: response._supportedEPSG?.map((el) => {
      return getProjectionCode(el);
    }),
    visibility: response._visibility,
    opacity: response._opacity,
    xy: true,
    geometryField: geometryField,
    geometryType: geometryType,
    geometryIsMulti: geometryIsMulti,
    attributes: response._attributesFields?.map((el) => {
      if (!el._attributeIsGeometry) {
        return {
          name: el,
          type: "string",
          title: el,
          value: null,
          editor: null,
          sortable: true,
          order: 0,
          visible: true,
          searchable: true,
          isVisible: true,
          showOnSummary: false,
        };
      }
    }),
    transparent: response._transparent,
    tiled: response._tiled,
    scales: response._scales,
    editable: response._isEditable,
    editCanCopy: response._canCopy,
    editCanTrace: response._canTrace,
    editCanSnapVertex: response._canSnapVertex,
    editCanSnapEdge: response._canSnapEdge,
    wmts: {
      matrixEPSG: getProjectionCode(response._matrixEPSG),
      matrixIds: response._matrixIds ? [...response._matrixIds] : [],
      matrixSet: response._matrixSet,
      topLeftCornerX: response._topLeftCornerX,
      topLeftCornerY: response._topLeftCornerY,
    },
    bbox: [
      response._bboxMinX,
      response._bboxMinY,
      response._bboxMaxX,
      response._bboxMaxY,
    ],
    dimensions: response._dimension?.[0]?.map((el) => {
      return moment(el).toISOString();
    }),
    defaultDimension: response._dimensionDefault
      ? moment(response._dimensionDefault).toISOString()
      : null,
    elevation: response._elevation,
    defaultElevation: response._elevationDefault,
    queryable: response._isQueryable,
    metadata: {
      url: response._layerMetadataURL,
    },
    legend: response._layerLegend,
    cqlFilter: response._cqlFilter,
    color: response._color,
  };
}

export function sourceResponseFormatter(response) {
  let {
    _api,
    _bbox,
    _featureInfoFormat,
    _isSecure,
    _isSecureLogged,
    _isService,
    _isVector,
    _password,
    _responsible_access_constrains,
    _responsible_email,
    _responsible_fees,
    _responsible_party,
    _responsible_person,
    _responsible_position,
    _serviceAbstract,
    _layers,
    _serviceId,
    _serviceName,
    _servicePort,
    _serviceProxyUrl,
    _serviceTitle,
    _serviceType,
    _serviceUrl,
    _supportedEPSG,
    _tiled,
    _username,
    _version,
  } = response;

  return {
    id: _serviceId,
    type: _serviceType,
    version: _version,
    url: _serviceUrl,
    name: _serviceName,
    title: _serviceTitle,
    abstract: _serviceAbstract,
    username: _username,
    password: _password,
    layers: [],
    metadata: {
      access_constrains: _responsible_access_constrains,
      fees: _responsible_fees,
      responsible: {
        email: _responsible_email,
        party: _responsible_party,
        person: _responsible_person,
        position: _responsible_position,
      },
    },
  };
}

export function fetchSourceResponseFormatter(response) {
  console.log(response);
  let data = {};
  if (response) {
    response.forEach((el) => {
      if (el._response) {
        data[el._response._serviceId] = sourceResponseFormatter(el._response);
      }
    });
  }
  return data;
}

export function getObjectFromObjectProperty(obj, property, value) {
  let object = null;

  Object.keys(obj)?.forEach((el) => {
    if (obj[el][property] === value) {
      object = el;
    }
  });

  return object;
}

export function getObjectFromArrayProperty(array, property, value) {
  let object = null;

  array.forEach((el) => {
    if (el[property] === value) {
      object = el;
    }
  });

  return object;
}

export function getUniqueValuesFromArray(array) {
  let newArray = [];

  array.forEach((el) => {
    if (newArray.indexOf(JSON.stringify(el)) < 0) {
      newArray.push(JSON.stringify(el));
    }
  });

  return newArray.map((el) => {
    return JSON.parse(el);
  });
}

export function getGeometryTypeFromLayer(geometryType) {
  if (geometryType?.toLowerCase().indexOf("point") >= 0) {
    return "point";
  }

  if (geometryType?.toLowerCase().indexOf("line") >= 0) {
    return "line";
  }

  return "polygon";
}
